import { t } from './i18n';

export function el(tag: string, cls = '', text?: string): HTMLElement {
  const e = document.createElement(tag);
  if (cls) e.className = cls;
  if (text !== undefined) e.textContent = text;
  return e;
}

export function showToast(msg: string, kind: 'info' | 'warn' | 'error' = 'info'): void {
  const node = document.createElement('div');
  node.className = `toast toast-${kind}`;
  node.textContent = msg;
  document.body.appendChild(node);
  setTimeout(() => node.classList.add('toast-show'), 10);
  setTimeout(() => {
    node.classList.remove('toast-show');
    setTimeout(() => node.remove(), 300);
  }, 3000);
}

export const NAME_BADGES: Array<{ test: RegExp; emoji: string; title: string }> = [
  { test: /lemonna/i, emoji: '🍋', title: 'Lemonna' },
  { test: /nekolan|naloken/i, emoji: '🌸', title: 'Nekolan' },
  { test: /sloks|dastan|detectiveslike/i, emoji: '🕵🏼', title: 'Beta tester' },
  { test: /skills|skittles|green_skittles/i, emoji: '💚', title: 'Skittles' },
];

export function nameBadge(name: string): { emoji: string; title: string } | null {
  for (const b of NAME_BADGES) if (b.test.test(name)) return { emoji: b.emoji, title: b.title };
  return null;
}

export function relativeTime(epochMs: number): string {
  const diff = Math.max(0, Date.now() - epochMs);
  const sec = Math.floor(diff / 1000);
  if (sec < 60) return t('time.justNow');
  const min = Math.floor(sec / 60);
  if (min < 60) return t('time.minutesAgo', { n: min });
  const hr = Math.floor(min / 60);
  return t('time.hoursAgo', { n: hr });
}
